import React, { useEffect, useState, useCallback } from "react";
import { useTable, useSortBy, usePagination, useFilters } from "react-table";

import { FaSortUp, FaSortDown, FaSort } from "react-icons/fa";

import DoencaService from "../../../main/services/DoencaService";
import PerfilAcessoService from "../../../main/services/PerfilAcessoService";
import MotivoSituacaoService from "../../../main/services/MotivoSituacaoService";
import SituacaoJuridicaService from "../../../main/services/SituacaoJuridicaService";
import TipoServicoAcolhimentoService from "../../../main/services/TipoServicoAcolhimentoService";
import { Link as ReactLink } from "react-router-dom";

import {
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Icon,
  Menu,
  MenuButton,
  MenuList,
  Link,
  MenuItem,
  IconButton,
} from "@chakra-ui/react";
import SemRegistros from "../SemRegistros";
import TablePagination from "../TablePagination";
import Filters from "../Filters";
import { isEmptyArray } from "formik";
import { BsEye, BsThreeDots } from "react-icons/bs";
import { FiEdit } from "react-icons/fi";
import { MdSettingsBackupRestore } from "react-icons/md";
import { BiBlock } from "react-icons/bi";
import {
  Permission,
  servicos,
  situacaoJuridica,
  motivoFunc,
  doencaFunc,
  criancaFunc,
} from "../../../helpers/Funcionalidades";

const Tabela = (props) => {
  const {
    data,
    fixedData,
    columns,
    entidade,
    placeholderFilter,
    setData,
    loading,
    roleKeycloack,
    tiposOrgao,
  } = props;

  const showItens =
    entidade === "tipo-servico-acolhimento"
      ? roleKeycloack &&
      (roleKeycloack.includes(servicos.tipoServicoVisualizar) ||
        roleKeycloack.includes(servicos.tipoServicoEditar) ||
        roleKeycloack.includes(servicos.tipoServicoReativar) ||
        roleKeycloack.includes(servicos.tipoServicoInativar))
      : entidade === "situacao-juridica"
        ? roleKeycloack &&
        (roleKeycloack.includes(situacaoJuridica.situacaoJuridicaVisualizar) ||
          roleKeycloack.includes(situacaoJuridica.situacaoJuridicaEditar) ||
          roleKeycloack.includes(situacaoJuridica.situacaoJuridicaReativar) ||
          roleKeycloack.includes(situacaoJuridica.situacaoJuridicaInativar))
        : entidade === "motivo-situacao"
          ? roleKeycloack &&
          (roleKeycloack.includes(motivoFunc.motivoVisualizar) ||
            roleKeycloack.includes(motivoFunc.motivoEditar) ||
            roleKeycloack.includes(motivoFunc.motivoReativar) ||
            roleKeycloack.includes(motivoFunc.motivoInativar))
          : entidade === "doenca"
            ? roleKeycloack &&
            (roleKeycloack.includes(doencaFunc.doencaVisualizar) ||
              roleKeycloack.includes(doencaFunc.doencaEditar) ||
              roleKeycloack.includes(doencaFunc.doencaReativar) ||
              roleKeycloack.includes(doencaFunc.doencaInativar))
            : entidade === "perfil-acesso"
              ? roleKeycloack && roleKeycloack.includes(criancaFunc.visualizarTudo)
              : "";

  const linkTo =
    entidade === "tipo-servico-acolhimento"
      ? "/tipo-servico-acolhimento/"
      : entidade === "situacao-juridica"
        ? "/situacao-juridica/"
        : entidade === "motivo-situacao"
          ? "/motivo-situacao/"
          : entidade === "doenca"
            ? "/doenca/"
            : entidade === "perfil-acesso"
              ? "/perfil-acesso/"
              : "";

  const [currentPage, setCurrentPage] = useState();
  const [nItens, setNItens] = useState(
    parseInt(sessionStorage.getItem(entidade + "-pagination-count")) || 10
  );
  const [filteringDesc, setFiltering] = useState(false);
  const [ordered, setOrdered] = useState([
    {
      id: "descricao",
      desc: false,
    },
    {
      id: "regime",
      desc: false,
    },
    {
      id: "pessoaFisicaCriancaResponse.nome",
      desc: false,
    },
  ]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    pageOptions,
    page,
    pageCount,
    prepareRow,
    canPreviousPage,
    canNextPage,
    gotoPage,
    rows,
    nextPage,
    previousPage,
    setPageSize,
    state: { filters, pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      sortTypes: {
        alphanumeric: (row1, row2, columnName) => {
          const rowOneColumn = String(row1.values[columnName]);
          const rowTwoColumn = String(row2.values[columnName]);
          if (isNaN(rowOneColumn)) {
            return rowOneColumn.toUpperCase() > rowTwoColumn.toUpperCase()
              ? 1
              : -1;
          }
          return Number(rowOneColumn) > Number(rowTwoColumn) ? 1 : -1;
        },
      },

      initialState: {
        filters: [],
        pageIndex: currentPage || 0,
        sortBy: sessionStorage.getItem("tabela-cadastros")
          ? JSON.parse(sessionStorage.getItem("tabela-cadastros")).filter(
            (order) => order.desc !== undefined
          )
          : [
            {
              id: "descricao",
              desc: false,
            },
            {
              id: "regime",
              desc: false,
            },
            {
              id: "pessoaFisicaCriancaResponse.nome",
              desc: false,
            },
          ],
        pageSize: nItens,
      },
    },
    useFilters,
    useSortBy,
    usePagination,
    (hooks) => {
      if (entidade === "tipo-servico-acolhimento" || entidade === "situacao-juridica" || entidade === "motivo-situacao" || entidade === 'doenca' || entidade === 'perfil-acesso') {
        hooks.visibleColumns.push((columns) => [
          ...columns,
          {
            Header: "Opções",
            accessor: "col4",
            disableSortBy: true,
            Cell: (props) => {
              const id = props.row.original.id;
              return (
                <Menu>
                  <MenuButton
                    as={IconButton}
                    icon={<BsThreeDots color="#fff" fontSize="20px" />}
                    variant={"link"}
                    cursor={"pointer"}
                    rounded={100}
                    p={2}
                    backgroundColor="#95BCBF"
                  />
                  {showItens && (
                    <MenuList>
                      <Permission
                        roleKeycloack={roleKeycloack}
                        func={
                          entidade === "tipo-servico-acolhimento"
                            ? servicos.tipoServicoVisualizar
                            : entidade === "situacao-juridica"
                              ? situacaoJuridica.situacaoJuridicaVisualizar
                              : entidade === "motivo-situacao"
                                ? motivoFunc.motivoVisualizar
                                : entidade === "doenca"
                                  ? doencaFunc.doencaVisualizar
                                  : entidade === "perfil-acesso"
                                    ? criancaFunc.visualizarTudo
                                    : ""
                        }
                      >
                        <Link
                          as={ReactLink}
                          color={"#374BCE"}
                          _hover={{ textDecoration: "none" }}
                          to={`${linkTo}` + id}
                        >
                          <MenuItem p={2}>
                            <BsEye />
                            <Text ml="5px">Visualizar</Text>
                          </MenuItem>
                        </Link>
                      </Permission>

                      {!props.row.original.dataFim && (
                        <Permission
                          roleKeycloack={roleKeycloack}
                          func={
                            entidade === "tipo-servico-acolhimento"
                              ? servicos.tipoServicoEditar
                              : entidade === "situacao-juridica"
                                ? situacaoJuridica.situacaoJuridicaEditar
                                : entidade === "motivo-situacao"
                                  ? motivoFunc.motivoEditar
                                  : entidade === "doenca"
                                    ? doencaFunc.doencaEditar
                                    : entidade === "perfil-acesso"
                                      ? criancaFunc.visualizarTudo
                                      : ""
                          }
                        >
                          <Link
                            as={ReactLink}
                            color={"#374BCE"}
                            _hover={{ textDecoration: "none" }}
                            to={`${linkTo}editar/` + id}
                          >
                            <MenuItem p={2}>
                              <FiEdit />
                              <Text ml="5px">Editar</Text>
                            </MenuItem>
                          </Link>
                        </Permission>
                      )}

                      {props.row.original.dataFim ? (
                        <Permission
                          roleKeycloack={roleKeycloack}
                          func={
                            entidade === "tipo-servico-acolhimento"
                              ? servicos.tipoServicoReativar
                              : entidade === "situacao-juridica"
                                ? situacaoJuridica.situacaoJuridicaReativar
                                : entidade === "motivo-situacao"
                                  ? motivoFunc.motivoReativar
                                  : entidade === "doenca"
                                    ? doencaFunc.doencaReativar
                                    : entidade === "perfil-acesso"
                                      ? criancaFunc.visualizarTudo
                                      : ""
                          }
                        >
                          <Link
                            as={ReactLink}
                            color={"green.500"}
                            _hover={{ textDecoration: "none" }}
                            to={
                              `${linkTo}alterar-vigencia/` + id
                            }
                          >
                            <MenuItem p={2}>
                              <MdSettingsBackupRestore />
                              <Text ml="5px">Reativar</Text>
                            </MenuItem>
                          </Link>
                        </Permission>
                      ) : (
                        <Permission
                          roleKeycloack={roleKeycloack}
                          func={
                            entidade === "tipo-servico-acolhimento"
                              ? servicos.tipoServicoInativar
                              : entidade === "situacao-juridica"
                                ? situacaoJuridica.situacaoJuridicaInativar
                                : entidade === "motivo-situacao"
                                  ? motivoFunc.motivoInativar
                                  : entidade === "doenca"
                                    ? doencaFunc.doencaInativar
                                    : entidade === "perfil-acesso"
                                      ? criancaFunc.visualizarTudo
                                      : ""
                          }
                        >
                          <Link
                            as={ReactLink}
                            color={"red.500"}
                            _hover={{ textDecoration: "none" }}
                            to={
                              `${linkTo}alterar-vigencia/` + id
                            }
                          >
                            <MenuItem p={2}>
                              <BiBlock />
                              <Text ml="5px">Inativar</Text>
                            </MenuItem>
                          </Link>
                        </Permission>
                      )}
                    </MenuList>
                  )}
                </Menu>
              );
            },
          },
        ]);
      }
    }
  );

  const [status, setStatus] = useState("");

  const [tipoSJ, setTipoSJ] = useState("");

  const [tipoMS, setTipoMS] = useState("");

  const [tipoPA, setTipoPA] = useState("");

  const [riscoVida, setRiscoVida] = useState("");

  const [extincaoPoderFamiliar, setExtincaoPoderFamiliar] = useState("");

  const [regime, setRegime] = useState("");

  const [modalidade, setModalidade] = useState();

  const [descricao, setDescricao] = useState();

  const [advancedFilter, setAdvancedFilter] = useState(false);

  const [shiftPressed] = useState(false);

  // const isValidDate = (value) => {
  //     if (!!value) {
  //         if (value.length === 10) {
  //             return isValid(parse(value, 'dd/MM/yyyy', new Date()));
  //         } else {
  //             return false;
  //         }
  //     } else {
  //         return true;
  //     }
  // };

  const irParaPagina = useCallback(
    (pagina) => {
      sessionStorage.setItem(entidade + "-pagination-page", pagina);
      gotoPage(pagina);
    },
    [entidade, gotoPage]
  );

  useEffect(() => {
    if (
      currentPage >
      parseInt(sessionStorage.getItem(entidade + "-pagination-page"))
    ) {
      irParaPagina(0);
    }
  }, [currentPage, entidade, irParaPagina]);

  function toggleAdFilter() {
    if (sessionStorage.getItem(entidade + "-filter-open")) {
      setAdvancedFilter(false);
      sessionStorage.removeItem(entidade + "-filter-open");
    } else {
      setAdvancedFilter(true);
      sessionStorage.setItem(entidade + "-filter-open", true);
    }
  }

  const limparFiltros = (e) => {
    setStatus("");
    setTipoSJ("");
    setTipoMS("");
    setTipoPA("");
    setRiscoVida("");
    setExtincaoPoderFamiliar("");
    setRegime("");
    setDescricao("");
    setModalidade("");
    setData(fixedData);
    sessionStorage.removeItem(entidade + "-filter");
  };

  useEffect(() => {
    let activeFilters = {};
    if (sessionStorage.getItem(entidade + "-filter")) {
      activeFilters = JSON.parse(sessionStorage.getItem(entidade + "-filter"));
      if (sessionStorage.getItem(entidade + "-filter-open")) {
        setAdvancedFilter(true);
      }
      setStatus(activeFilters.status);
      setTipoSJ(activeFilters.tipo);
      setTipoMS(activeFilters.tipo);
      setTipoPA(activeFilters.tipo);
      setRiscoVida(activeFilters.riscoVida);
      setExtincaoPoderFamiliar(activeFilters.extincaoPoderFamiliar);
      setRegime(activeFilters.regime);
      setDescricao(activeFilters.descricao);
      setModalidade(activeFilters.modalidade);
      setCurrentPage(
        parseInt(sessionStorage.getItem(entidade + "-pagination-page"))
      );

      setNItens(
        parseInt(sessionStorage.getItem(entidade + "-pagination-count"))
      );
    }
    if (sessionStorage.getItem("tabela-cadastros")) {
      setOrdered(
        JSON.parse(sessionStorage.getItem("tabela-cadastros")).filter(
          (order) => order.desc !== undefined
        )
      );
    }
  }, [entidade]);
  const filtrar = useCallback(() => {
    if (entidade === "doenca") {
      DoencaService.pesquisarDoenca(descricao, status ? status.value : "").then(
        (res) => {
          setData(res.data);
        }
      );
    }
    if (entidade === "motivo-situacao") {
      MotivoSituacaoService.pesquisarMotivoSituacao(
        descricao,
        status ? status.value : "",
        tipoMS ? tipoMS.value : "",
        riscoVida ? riscoVida.value : "",
        extincaoPoderFamiliar ? extincaoPoderFamiliar.value : ""
      ).then((res) => {
        setData(res.data);
      });
    }
    if (entidade === "situacao-juridica") {
      SituacaoJuridicaService.pesquisarSituacaoJuridica(
        descricao,
        status ? status.value : "",
        tipoSJ ? tipoSJ.value : ""
      ).then((res) => {
        setData(res.data);
      });
    }
    if (entidade === "tipo-servico-acolhimento") {
      TipoServicoAcolhimentoService.pesquisarTipoServicoAcolhimento(
        modalidade,
        status ? status.value : "",
        regime ? regime.value : ""
      ).then((res) => {
        setData(res.data);
      });
    }
    if (entidade === "perfil-acesso") {
      PerfilAcessoService.pesquisarPerfilAcesso(
        descricao,
        status ? status.value : "",
        tipoPA ? tipoPA.value : ""
      ).then((res) => {
        setData(res.data);
      });
    }
  }, [
    descricao,
    entidade,
    extincaoPoderFamiliar,
    modalidade,
    regime,
    setData,
    riscoVida,
    status,
    tipoMS,
    tipoSJ,
    tipoPA,
  ]);

  const aplicarFiltros = useCallback(() => {
    let filtersS = {
      entidade: entidade,
      status: status,
    };
    if (entidade === "situacao-juridica") {
      filtersS.tipo = tipoSJ;
    }

    if (entidade === "motivo-situacao") {
      filtersS.tipo = tipoMS;
      filtersS.riscoVida = riscoVida;
      filtersS.extincaoPoderFamiliar = extincaoPoderFamiliar;
    }
    if (entidade === "perfil-acesso") {
      filtersS.tipo = tipoPA;
    }
    if (entidade === "tipo-servico-acolhimento") {
      filtersS.regime = regime;
    }

    if (entidade === "tipo-servico-acolhimento") {
      filtersS.modalidade = modalidade;
    } else {
      filtersS.descricao = descricao;
    }
    sessionStorage.setItem(entidade + "-filter", JSON.stringify(filtersS));

    filtrar();
  }, [
    descricao,
    entidade,
    extincaoPoderFamiliar,
    filtrar,
    modalidade,
    regime,
    riscoVida,
    status,
    tipoMS,
    tipoSJ,
    tipoPA,
  ]);

  useEffect(() => {
    if (!isEmptyArray(fixedData)) {
      if (sessionStorage.getItem(entidade + "-filter")) {
        let item = JSON.parse(sessionStorage.getItem(entidade + "-filter"));
        item.descricao = descricao;

        if (sessionStorage.getItem(entidade + "-filtering")) {
          setCurrentPage(0);
        }
        sessionStorage.setItem(entidade + "-pagination-page", currentPage);
        sessionStorage.setItem(entidade + "-filter", JSON.stringify(item));
        setFiltering(false);
        sessionStorage.removeItem(entidade + "-filtering");
      }
    }
    if (descricao !== undefined) {
      aplicarFiltros();
    }
  }, [descricao, aplicarFiltros, currentPage, entidade, fixedData]);

  useEffect(() => {
    if (entidade === "tipo-servico-acolhimento") {
      if (!isEmptyArray(fixedData)) {
        if (sessionStorage.getItem(entidade + "-filter")) {
          let item = JSON.parse(sessionStorage.getItem(entidade + "-filter"));
          item.modalidade = modalidade;

          if (sessionStorage.getItem(entidade + "-filtering")) {
            setCurrentPage(0);
          }
          sessionStorage.setItem(entidade + "-pagination-page", currentPage);
          sessionStorage.setItem(entidade + "-filter", JSON.stringify(item));
          setFiltering(false);
          sessionStorage.removeItem(entidade + "-filtering");
        }
      }
      if (modalidade !== undefined) {
        aplicarFiltros();
      }
    }
  }, [modalidade, aplicarFiltros, currentPage, entidade, fixedData]);

  useEffect(() => {
    if (
      status ||
      tipoSJ ||
      tipoMS ||
      tipoPA ||
      riscoVida ||
      regime ||
      extincaoPoderFamiliar
    ) {
      aplicarFiltros();
    }
  }, [
    status,
    tipoSJ,
    tipoMS,
    tipoPA,
    riscoVida,
    regime,
    extincaoPoderFamiliar,
    aplicarFiltros,
  ]);

  const handleSortingPersistence = (column) => {
    const hasOrdered = ordered.find((order) => order.id === column.id);
    let sortedDesc;
    const tempOrdered = [];

    if (!shiftPressed) {
      sessionStorage.removeItem("tabela-cadastros");
    }

    if (!shiftPressed && ordered.length > 1 && column.isSortedDesc === false) {
      sortedDesc = column.isSortedDesc;
    } else {
      switch (column.isSortedDesc) {
        case true:
          sortedDesc = undefined;
          break;
        case false:
          sortedDesc = true;
          break;
        default:
          sortedDesc = false;
          break;
      }
    }

    if (shiftPressed) {
      if (hasOrdered) {
        tempOrdered.push(
          ...ordered.map((order) => {
            if (order.id === column.id) {
              return { id: column.id, desc: sortedDesc };
            } else {
              return order;
            }
          })
        );
        setOrdered(tempOrdered);
      } else {
        tempOrdered.push(...ordered);
        tempOrdered.push({ id: column.id, desc: sortedDesc });
        setOrdered(tempOrdered);
      }
    } else {
      tempOrdered.push({ id: column.id, desc: sortedDesc });
      setOrdered(tempOrdered);
    }

    sessionStorage.setItem("tabela-cadastros", JSON.stringify(tempOrdered));
  };

  function findByEnter(e) {
    if (e.key === "Enter") {
      aplicarFiltros();
    }
  }

  function selecionarTotalItens(nItens) {
    sessionStorage.setItem(entidade + "-pagination-count", nItens);
    setPageSize(nItens);
  }

  return (
    <Flex flexDir="column" w="100%">
      <Flex flexDir={"column"}>
        <Flex flexDir={["column", "row"]} justifyContent="space-between">
          <Filters
            filtering={filteringDesc}
            setFiltering={setFiltering}
            irParaPagina={irParaPagina}
            descricaoPai={descricao}
            setDescricao={setDescricao}
            filtrarDescricao={aplicarFiltros}
            placeholderFilter={placeholderFilter}
            findByEnter={findByEnter}
            data={data}
            limparFiltros={limparFiltros}
            status={status}
            setStatus={setStatus}
            entidade={entidade}
            setTipoSJ={setTipoSJ}
            tipoSJ={tipoSJ}
            tipoMS={tipoMS}
            setTipoMS={setTipoMS}
            riscoVida={riscoVida}
            setRiscoVida={setRiscoVida}
            extincaoPoderFamiliar={extincaoPoderFamiliar}
            setExtincaoPoderFamiliar={setExtincaoPoderFamiliar}
            filtrar={aplicarFiltros}
            toggleAdFilter={toggleAdFilter}
            adFilter={advancedFilter}
            advancedFilter={advancedFilter}
            setDescricaoPai={setDescricao}
            setModalidade={setModalidade}
            modalidade={modalidade}
            regime={regime}
            setRegime={setRegime}
            tipoPA={tipoPA}
            setTipoPA={setTipoPA}
            tiposOrgao={tiposOrgao}
            roleKeycloack={roleKeycloack}
          />
        </Flex>
        <Flex flexDir="column" width="100%" mt={10} h="100%">
          <Flex w={"100%"} flexDir={"column"}>
            {data.length === 0 && isEmptyArray(filters) ? (
              <SemRegistros loading={loading} entidade={entidade} />
            ) : (
              <Flex flexDir={"column"}>
                <Flex overflowX="auto" pb={5}>
                  <Table {...getTableProps} backgroundColor="white">
                    <Thead backgroundColor="#ECEFF1">
                      {headerGroups.map((headerGroup) => (
                        <Tr {...headerGroup.getHeaderGroupProps()}>
                          {headerGroup.headers.map((column) => (
                            <Th
                              {...column.getHeaderProps(
                                column.getSortByToggleProps({
                                  title: undefined,
                                })
                              )}
                              w={column.Header === "Descrição" && "56%"}
                              p="0px"
                            >
                              <Flex
                                flexDir="row"
                                alignContent="center"
                                px="24px"
                                py="12px"
                                onClick={
                                  column.Header !== "Selecione"
                                    ? () => {
                                      handleSortingPersistence(column);
                                    }
                                    : null
                                }
                              >
                                <Text as="p">{column.render("Header")}</Text>

                                {column.Header !== "Opções" ? (
                                  <Flex pl={1} alignItems="center">
                                    {column.isSorted ? (
                                      column.isSortedDesc ? (
                                        <Icon as={FaSortDown} boxSize="14px" />
                                      ) : (
                                        <Icon as={FaSortUp} boxSize="14px" />
                                      )
                                    ) : (
                                      <Icon as={FaSort} boxSize="14px" />
                                    )}
                                  </Flex>
                                ) : (
                                  ""
                                )}
                              </Flex>
                            </Th>
                          ))}
                        </Tr>
                      ))}
                    </Thead>
                    <Tbody {...getTableBodyProps}>
                      {page.map((row, i) => {
                        prepareRow(row);
                        return (
                          <Tr {...row.getRowProps()}>
                            {row.cells.map((cell) => {
                              return (
                                <Td {...cell.getCellProps()}>
                                  {cell.render("Cell")}
                                </Td>
                              );
                            })}
                          </Tr>
                        );
                      })}
                    </Tbody>
                  </Table>
                </Flex>
                <TablePagination
                  nItens={nItens}
                  selecionarTotalItens={selecionarTotalItens}
                  irParaPagina={irParaPagina}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  rows={rows}
                  gotoPage={gotoPage}
                  canPreviousPage={canPreviousPage}
                  previousPage={previousPage}
                  pageOptions={pageOptions}
                  pageIndex={pageIndex}
                  canNextPage={canNextPage}
                  nextPage={nextPage}
                  pageCount={pageCount}
                />
              </Flex>
            )}
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};
export default Tabela;
